import type { ReactNode } from 'react';
import { panel, sectionTitle } from '../lib/ui';

/** 長い文書（プライバシーポリシー・利用規約）の 1 節。見出しと本文を 1 枚のカードに収める。 */
export function DocumentSection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className={panel}>
      <h2 className={sectionTitle}>{title}</h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}
